<template>
    <div id="app">
        <div class="bar"></div>
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div class="img-box">
                    <img src="../assets/logo1.png" alt="">
                </div>
            </div>
            <!-- 导航 -->
            <div class="nav-list">
                <div @click="handleSelect(index + 1)" v-for="(item, index) in list" :key="index" class="nav-item"
                    :class="index == activeIndex ? 'nav-item-ac' : ''">{{
                        item.name }}</div>
            </div>
            <!-- <el-button type="text" class="header-title btn"></el-button> -->
            <div @click="login" class="login-btn">合作伙伴登录</div>
            <!-- <el-button type="primary" class="header-title" @click="register" round>注册</el-button> -->
        </div>
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>
        <!-- 底部 -->
        <div class="footer">
            <div class="footer-left">
                <div class="f-l-tab">
                    <span @click="foorterClick(index)" v-for="(item, index) in foorterList" :key="'f-l-tab' + index">{{ item
                    }}</span>
                </div>
                <div class="f-l-tip">Copyright © 2024 XinYuWei All Rights Reserved 鲁ICP备20000246号-1</div>
                <div class="">新域伟科技 地址：山东省济南市历下区经十路9777号鲁商国奥城4号楼26层 业务咨询：0531-82952188</div>
            </div>
            <div class="footer-right">
                <div class="gzh-sph">
                    <img src="https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/gzh.png" alt="">
                    <div class="">
                        <p>微信扫一扫</p>
                        <p>关注公众号</p>
                    </div>
                </div>
                <div class="gzh-sph">
                    <img src="https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/sph.png" alt="">
                    <div class="">
                        <p>微信扫一扫</p>
                        <p>关注视频号</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="call">
            <span>0531-82952188</span>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <div class="top"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Layout",
    data() {
        return {
            activeIndex: '0',
            list: [
                {
                    name: '首页',
                    id: 1
                },
                {
                    name: '产品介绍',
                    id: 2
                },
                {
                    name: '案例客户',
                    id: 3
                },
                {
                    name: '关于我们',
                    id: 4
                },
                {
                    name: '服务与支持',
                    id: 5
                }
            ],
            scroll: '',
            timer: '',
            seen: true,
            currentMenu: '首页',
            path: '',
            foorterList: ['网站首页', '产品介绍', '案例客户', '关于我们', '服务与支持']
        };
    },
    created() {
        // console.log(this.$route, 'this.$route');
        this.$router.beforeEach((to, from, next) => {
            this.path = to.path
            this.getActiveIndex()
            next(); // 必须调用next()才能完成路由切换
        })
    },
    mounted() {
        //  路由匹配activeIndex
        this.getActiveIndex()
        this.menuSeen()
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleSelect(key) {
            this.activeIndex = key - 1
            switch (key) {
                case 1:
                    this.$router.replace({ name: "Index" });
                    break;
                case 2:
                    this.$router.replace({ name: "productDetail" });
                    break;
                case 3:
                    this.$router.replace({ name: "caseUser" });
                    break;
                case 4:
                    this.$router.replace({ name: "aboutUs" });
                    break;
                case 5:
                    this.$router.replace({ name: "ServiceAndSupport" });
                    break;
            }
            this.backTop()
        },
        handleScroll() {
            this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 600) {  //判断滚动后高度超过400px,就显示
                this.$refs.btn.style.display = 'block';
            } else {
                this.$refs.btn.style.display = 'none'
            }
        },
        backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
            // this.timer = setInterval(() => {
            //     let osTop = document.documentElement.scrollTop || document.body.scrollTop;
            //     let ispeed = Math.floor(-osTop / 5)
            // document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
            document.documentElement.scrollTop = 0;
            //     if (osTop === 0) {
            //         clearInterval(this.timer)
            //     }
            // }, 30)
        },
        login() {
            window.open('https://xyw.xinyuwei.com.cn')
        },
        // register() {
        //     window.open('https://admin.fastice-tech.com/registe')
        // },
        menuSeen() {
            // 屏幕尺寸
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                this.seen = true;
            } else {
                this.seen = false;
            }
        },
        logoClick() {
            this.$router.push({ name: "Index" });
            this.activeIndex = 0
            this.backTop()
        },
        //  路由匹配activeIndex
        getActiveIndex() {
            setTimeout(() => {
                console.log(this.$route, 'this.$route');
                this.path = this.$route.path
                if (this.path.indexOf('case') != -1) {
                    this.activeIndex = 2
                }
                switch (this.path) {
                    case '/':
                        this.activeIndex = 0
                        break;
                    case '/productDetail':
                        this.activeIndex = 1
                        break;
                    case '/aboutUs':
                        this.activeIndex = 3
                        break;
                    case '/serviceAndSupport':
                        this.activeIndex = 4
                        break;

                    default:
                        break;
                }
            }, 100)
        },
        foorterClick(key) {
            switch (key) {
                case 0:
                    this.$router.replace({ name: "Index" });
                    break;
                case 1:
                    this.$router.replace({ name: "productDetail" });
                    break;
                case 2:
                    this.$router.replace({ name: "caseUser" });
                    break;
                case 3:
                    this.$router.replace({ name: "aboutUs" });
                    break;
                case 4:
                    this.$router.replace({ name: "ServiceAndSupport" });
                    break;
            }
            this.backTop()
        }
    }
}
</script>

<style lang="scss" scoped>
.bar {
    height: 80px;
}

.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    height: 80px;
}

.logo_img {
    width: 30%;
    cursor: pointer;

    .img-box {
        height: 100%;
        display: flex;
        align-items: center;
        margin-left: 269px;

        img {
            width: 145px;
            height: 50px;
            object-fit: contain;
        }
    }
}

#back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer
}

.nav-list {
    font-size: 16px;
    color: #333;
    display: flex;
    align-items: center;
    margin-left: 200px;

    .nav-item {
        white-space: nowrap;
        width: 80px;
        height: 100%;
        line-height: 80px;
        text-align: center;
        margin-right: 67px;
        cursor: pointer;
        height: 100%;
    }

    .nav-item-ac {
        color: #0267FE;
    }
}

.header-title {
    font-size: 16px;
}

.login-btn {
    font-size: 16px;
    color: #0267FE;
    margin-right: 40px;
    line-height: 80px;
    cursor: pointer;
}

// .btn {
//     margin-right: 40px;
// }

.company_name {
    font-weight: normal;
    font-size: 1em;
}

.footer_font {
    font-size: 1em;
}

/* @media screen and (max-device-width: 415px) {
    .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer
    }

    .footer_font {
        font-size: 0.875em;
    }

    #menu_index {
        float: right;
        width: auto;
        height: 100%
    }

    .mobile_menu {}
} */

#header-img {
    width: 50px;
    height: 50px;
    float: left;
    margin: auto;
}



.footer {
    display: flex;
    align-items: center;
    height: 240px;
    background: url('../assets/db.png') no-repeat;
    background-size: cover;

    .footer-left {
        font-size: 14px;
        color: #5E677A;
        margin: 0 122px 0 300px;

        .f-l-tab {
            font-size: 17px;
            color: #333;

            span {
                margin-right: 34px;
                cursor: pointer;
            }
        }

        .f-l-tip {
            margin: 29px 0;
        }
    }

    .footer-right {
        display: flex !important;

        .gzh-sph {
            display: flex;
            font-size: 14px;
            color: #5E677A;
            margin-right: 76px;

            p {
                margin-bottom: 19px;
            }

            img {
                width: 95px;
                height: 95px;
                margin-right: 34px;
            }
        }
    }
}

.call {
    width: 80px;
    height: 80px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: fixed;
    bottom: 150px;
    right: 30px;
    cursor: pointer;
    background: url('../assets/call.png') no-repeat;
    background-size: cover;
    font-size: 24px;
    color: #fff;
    box-sizing: border-box;
    z-index: 11;

    span {
        display: none;
        margin-left: 92px;
        line-height: 80px;
    }

    &:hover {
        width: 307px;
        background: url('../assets/hover-call.png') no-repeat;
        background-size: cover;

        span {
            display: block;
        }
    }
}

.top {
    width: 80px;
    height: 80px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background: url('../assets/top.png') no-repeat;
    background-size: cover;

    &:hover {
        background: url('../assets/hover-top.png') no-repeat;
        background-size: cover;
    }
}

a {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}
</style>
